import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class CurrencyService {
  constructor(private http: HttpClient) {}
  getCurrencies(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get('../../../../assets/data/currencies.json').subscribe(
        (response: any) => {
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
    });
  }
}
